var scope_0 = require('/home/kevin/Documents/mdx_presentation/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/09baf392b961f4cc26ee449a6e882821.js').default;export default
        Object.assign({}, scope_0 )
    